export const SET_ACTIVE = 'SET_ACTIVE';
export const SET_LEAVE_INTENTION = 'SET_LEAVE_INTENTION';
export const SET_CONTACT_INTENTION = 'SET_CONTACT_INTENTION';
export const SET_SCROLL = 'SET_SCROLL';
export const SET_STATUS = 'SET_STATUS';
export const SET_ID = 'SET_ID';
export const SET_VERSION = 'SET_VERSION';
export const SET_EXTERNAL = 'SET_EXTERNAL';
export const SET_PACKAGE = 'SET_PACKAGE';
export const SET_PREPACKAGE = 'SET_PREPACKAGE';
export const SET_TRACKING_PACKAGE = 'SET_TRACKING_PACKAGE';
export const SET_AVAILABLE_NUMBERS = 'SET_AVAILABLE_NUMBERS';
export const SET_SETTINGS_NAME = 'SET_SETTINGS_NAME';
export const SET_FRAME_VISIBILITY = 'SET_FRAME_VISIBILITY';
export const SET_FRAME_URL = 'SET_FRAME_URL';
export const SET_AUTH = 'SET_AUTH';
export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN';
export const SET_SALES_GATEWAY = 'SET_SALES_GATEWAY';
export const SET_MODE = 'SET_MODE';
export const SET_REFERRAL = 'SET_REFERRAL';
export const SET_EDITABLE = 'SET_EDITABLE';
export const SET_AS_BUNDLE = 'SET_AS_BUNDLE';
export const SET_PORTABLE_INFO = 'SET_PORTABLE_INFO';

export default {
  SET_ACTIVE,
  SET_LEAVE_INTENTION,
  SET_CONTACT_INTENTION,
  SET_SCROLL,
  SET_STATUS,
  SET_ID,
  SET_VERSION,
  SET_EXTERNAL,
  SET_PACKAGE,
  SET_PREPACKAGE,
  SET_TRACKING_PACKAGE,
  SET_AVAILABLE_NUMBERS,
  SET_SETTINGS_NAME,
  SET_FRAME_VISIBILITY,
  SET_FRAME_URL,
  SET_AUTH,
  SET_AUTH_TOKEN,
  SET_SALES_GATEWAY,
  SET_MODE,
  SET_REFERRAL,
  SET_EDITABLE,
  SET_AS_BUNDLE,
  SET_PORTABLE_INFO
};



// WEBPACK FOOTER //
// ./src/store/modules/simulation/types.js